import {
    Box,
    Card,
    Typography
} from '@mui/material';

import { IssueSummaryPieChart } from './IssueSummaryPieChart';
import { Property } from "../../API";
import { Property as PropertyModel } from "../../models";
import { PropertySetting } from './PropertySetting';
import { QRCodeButton } from './QRCodeButton';
import React from 'react';
import { useIssues } from './contexts/IssuesContextProvider';
import { useLocation } from 'react-router-dom';
import { useLocations } from './contexts/LocationContextProvider';

interface PropertyStatisticsProps {
    property: Property;
}

export const PropertyStatistics: React.FC<PropertyStatisticsProps> = (props) => {
    const { property } = props;
    const { issues } = useIssues();
    const { locations } = useLocations();
    const location = useLocation();
    const isPublic = location.pathname.includes('public');

    return (
        <>
            <Card sx={{ p: 1.5 }}>
                <Box
                    display="flex"
                    flex={1}
                    flexGrow={1}
                    gap={2}
                    flexDirection={{ xs: 'column', md: 'row' }}
                >
                    {/* Left column - Property Information */}
                    <Box flex={1} order={{ xs: 2, md: 1 }}>
                        <Typography fontSize="1.5rem" fontWeight={500} sx={{ gridColumn: "1/-1" }}>
                            Property
                        </Typography>
                        <Box display="grid" gridTemplateColumns="max-content 1fr" gap={1} flex={1} pl={1}>
                            <Typography fontWeight={500}>
                                Address:
                            </Typography>
                            <Typography>
                                {property.address || 'N/A'}
                            </Typography>
                            {property.description && (
                                <>
                                    <Typography fontWeight={500}>
                                        Description:
                                    </Typography>
                                    <Typography>
                                        {property.description}
                                    </Typography>
                                </>
                            )}
                        </Box>
                        <Typography fontSize="1.5rem" fontWeight={500} sx={{ gridColumn: "1/-1", mt: 1 }}>
                            Contact Info
                        </Typography>
                        <Box display="grid" gridTemplateColumns="max-content 1fr" gap={1} flex={1} pl={1}>
                            <Typography fontWeight={500}>
                                Name:
                            </Typography>
                            <Typography>
                                {property.primaryContactName || 'N/A'}
                            </Typography>
                            <Typography fontWeight={500}>
                                Email:
                            </Typography>
                            <Typography>
                                {property.primaryContactEmail || 'N/A'}
                            </Typography>
                            <Typography fontWeight={500}>
                                Phone:
                            </Typography>
                            <Typography>
                                {property.primaryContactNumber || 'N/A'}
                            </Typography>
                        </Box>
                        <PropertySetting
                            property={property}
                        />
                    </Box>

                    {/* Right column - Button and Pie Chart */}
                    <Box
                        display="flex"
                        flexDirection="column"
                        flex={1}
                        gap={2}
                        alignItems={{ xs: 'center', md: 'flex-start' }}
                        order={{ xs: 1, md: 2 }}
                    >
                        {!isPublic && (
                            <Box display="flex" justifyContent={{ xs: 'center', md: 'flex-end' }} width="100%">
                                <QRCodeButton
                                    property={property as PropertyModel}
                                    locations={locations}
                                />
                            </Box>
                        )}
                        <Box display="flex" justifyContent="center" alignItems="center" flex={1} width="100%">
                            <IssueSummaryPieChart issues={issues} />
                        </Box>
                    </Box>
                </Box>
            </Card>
        </>
    );
};